import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const initMenuViewport = () => {
  const menus = document.querySelectorAll('.menus__menu')
  const menuBar = document.querySelector('.menus__links')
  const menuItems = document.querySelectorAll('.menus__link-button')

  if (!menus.length) return

  menus.forEach((menu, index) => {
    const menuItem = document.querySelector(`.menus__link-button[data-section="${menu.id}"]`)

    if (!menuItem) return

    ScrollTrigger.create({
      trigger: menu,
      start: 'top center',
      end: 'bottom center',
      onToggle: (self) => self.isActive && setActive(menuItem),
    })

    function setActive(link) {
      menuItems.forEach((el) => el.classList.remove('active'))
      link.classList.add('active')
      menuBar.scrollTo({ left: link.offsetLeft - 20, behavior: 'smooth' })
    }
  })
}

export default () => {}
